import { render, staticRenderFns } from "./BattleCrewDetailsParticipant.vue?vue&type=template&id=23d6638b&scoped=true"
import script from "./BattleCrewDetailsParticipant.vue?vue&type=script&lang=js"
export * from "./BattleCrewDetailsParticipant.vue?vue&type=script&lang=js"
import style0 from "./BattleCrewDetailsParticipant.vue?vue&type=style&index=0&id=23d6638b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d6638b",
  null
  
)

export default component.exports